// extracted by mini-css-extract-plugin
export var closeButton = "_jp-1";
export var closeX = "_jp-3";
export var container = "_jp-0";
export var image = "_jp-2";